import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class PackageRenewalService {
  private readonly url = 'iam-sales/package-renewal';

  constructor(private http: HttpClient) {
  }

  getStatus(): Observable<any> {
    return this.http.get(this.url);
  }

  getProducts(): Observable<any> {
    return this.http.get(`${this.url}/products`);
  }

  createCheckout(productId: string): Observable<any> {
    return this.http.post(`${this.url}/checkout`, {productId});
  }

  reportPayment(paymentId: string, data: {emailAddress: string; contactNumber: string}): Observable<any> {
    return this.http.put(`${this.url}/payments/${paymentId}/report`, data);
  }

  cancelPayment(paymentId: string): Observable<any> {
    return this.http.put(`${this.url}/payments/${paymentId}/cancel`, {});
  }
}
